<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16" 
  >
    <path d="M3.77765 13.9178C3.44539 14.1396 3 13.9015 3 13.5019V4.01076C3 2.90759 3.89325 2.01274 4.99642 2.01076L10.9964 2C12.101 1.99803 12.998 2.89186 13 3.99643V13.5019C13 13.9015 12.5546 14.1396 12.2224 13.9178L8 11.0985L3.77765 13.9178ZM12 4.00001L11.9931 3.88161C11.9344 3.38437 11.511 2.99909 10.9982 3.00001L4.99821 3.01076C4.44662 3.01175 4 3.45917 4 4.01076V12.5669L7.72235 10.0815C7.89044 9.96926 8.10956 9.96926 8.27765 10.0815L12 12.5669V4.00001Z" fill="#0F0017"/>
  </svg>
</template>
